<div class="info-type-container info-type-{{ type }}">
  <div class="info-header">
    @if (icon) {
      <span class="mb-icon mb-icon-{{ icon }}"></span>
    }
    <ng-content select="[headline]"></ng-content>
  </div>
  <ng-content></ng-content>
</div>
